
import { defineComponent, onMounted, ref, toRefs, reactive } from "vue";
import Header from "@/components/Header.vue";
import Bottom from "@/components/Bottom.vue";
import News from "@/components/News.vue";
import { useRoute } from "vue-router";
import { selArticleList } from "@/api/index";
export default defineComponent({
  name: "newsList",
  components: {
    Header,
    Bottom,
    News
  },
  setup() {
    const route = useRoute();
    const page = ref(1);

    const limit = ref(6);

    const total = ref(0);

    const data = reactive({
      newsList: Array<any>()
    });

    const getList = async () => {
      const params = {
        menu_id: route.query.id,
        orderType: "sort_code",
        status: 1,
        limit: limit.value,
        page: page.value
      };
      data.newsList = [];
      await selArticleList(params)
        .then((res: any) => {
          data.newsList = res.data;
          //获取总新闻条数
          total.value = res.count;
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const handleCurrentChange = (val: number) => {
      page.value = val;
      getList();
    };

    onMounted(() => {
      getList();
    });
    return {
      ...toRefs(data),
      page,
      limit,
      total,
      handleCurrentChange
    };
  }
});
